module.exports = __webpack_public_path__ + "static/img/not_found_exchange.2f67d16.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/common/img/not_found_exchange.png
// module id = jShr
// module chunks = 37